/**
 * Global configuration for the application
 * Updated for Cloudflare Pages + Workers
 */

// API configuration - Works with Cloudflare Workers
const apiBaseUrl = (() => {
  // Build-time env (from Cloudflare Pages build or Vite)
  const envUrl = import.meta.env.VITE_API_URL;
  if (envUrl) {
    return envUrl;
  }

  // Fallback for local development with Workers
  if (import.meta.env.DEV) {
    return 'http://localhost:8787/api'; // Workers dev server on port 8787
  }

  // Production without config - fail fast
  throw new Error(
    'VITE_API_URL is not configured. ' +
    'Set VITE_API_URL environment variable during build.'
  );
})();

// WebSocket configuration (for future Durable Objects)
const getWebSocketUrl = (): string => {
  const url = import.meta.env.VITE_WS_URL;
  if (url) return url;

  // Derive from API URL - Workers WebSocket endpoint
  return apiBaseUrl.replace(/^http/, 'ws').replace(/\/api$/, '/ws');
};

const wsUrl = getWebSocketUrl();

// Default route after login
const defaultRoute = '/dashboard';

// Application metadata
const appName = 'نعيم';
const appDescription = 'نظام المحاسبة لمطعم نعيم';

// Branding assets - served from frontend public directory
const logoUrl = '/logo.jpg';
const loginBackgroundUrl = '/logo.jpg';
const useFallbackGradient = false;

// Storage keys
const storageKeys = {
  auth: 'auth-storage',
  settings: 'settings',
  theme: 'theme-mode',
} as const;

// Router mode: 'frontend' | 'backend'
const routerMode = 'frontend';

const GLOBAL_CONFIG = {
  apiBaseUrl,
  wsUrl,
  defaultRoute,
  appName,
  appDescription,
  logoUrl,
  loginBackgroundUrl,
  useFallbackGradient,
  storageKeys,
  routerMode,
} as const;

export default GLOBAL_CONFIG;
